import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';
import CustomTable from '../../../components/CustomTable';
import auth from "../../../common/utility/auth";

const REGISTRADO = 1;
const ENVIADO = 2;
const ANULADO = 3;

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idHonorarioEstado === REGISTRADO)
            return 'blue';
        if (row.idHonorarioEstado === ENVIADO)
            return 'green';
        if (row.idHonorarioEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={row.idHonorarioEstado == REGISTRADO ? false : true}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    icon="check"
                                    size={"small"}
                                    disabled={row.idHonorarioEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onAprobar(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idHonorarioEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'nombreTipoComprobante',
                    sorter: true
                },

                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha Emisión',
                    dataIndex: 'fechaDocumento',
                    key: 'fechaDocumento',
                    sorter: true
                },

                {
                    title: 'Fecha Recepción',
                    dataIndex: 'fechaRecepcionStr',
                    key: 'fechaRecepcionStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'nombreTipoDocumentoEntidad',
                    key: 'nombreTipoDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoEntidad',
                    key: 'numeroDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Razón Social',
                    dataIndex: 'razonSocialEntidad',
                    key: 'razonSocialProveedor',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Importe Honorario',
                    dataIndex: 'importe',
                    key: 'importe',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Retención IR',
                    dataIndex: 'retencion',
                    key: 'retencion',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Importe Neto',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreHonorarioEstado',
                    key: 'nombreHonorarioEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}